$(function() {

  $('.recruit-content').each(function() {
    const $section = $(this);
    const $body = $section.find('.js-body');
    const $acdn = $section.find('.recruit-content__acdn');
    const $trigger = $section.find('.recruit-content__trigger');

    function toggleAcdn() {
      $body.stop(true, true).slideToggle(300);
      $acdn.toggleClass('is-open');
      $trigger.toggleClass('is-open');
    }

    $trigger.on('click', toggleAcdn);
    $acdn.on('click', toggleAcdn);
  });

});
